import { useContext, useState } from "react";
import Swal from "sweetalert2";
import UserContext from "../../contexts/UserContext";
import PasswordLoginCard from "./PasswordLoginCard";

const HotelOwnerLoginCard = () => {
  const { hotelOwnerLogin, verifyHotelOwnerOtp } = useContext(UserContext);
  const [otpChallenge, setOtpChallenge] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (otpChallenge) {
      verifyHotelOwnerOtp(
        {
          challengeToken: otpChallenge.challengeToken,
          otp: event.target.verification_code.value,
        },
        (data) => {
          if (data.success && data.token) {
            window.location.href = process.env.PUBLIC_URL + "/dashboard";
          } else {
            Swal.fire({
              title: "Verification Failed",
              text: data.message,
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        },
      );
      return;
    }

    const body = {
      username: event.target.username.value,
      password: event.target.password.value,
    };

    hotelOwnerLogin(body, (data) => {
      if (data.otpRequired) {
        setOtpChallenge(data);
      } else if (data.success && data.token) {
        window.location.href = process.env.PUBLIC_URL + "/dashboard";
      } else {
        Swal.fire({
          title: "Login Failed",
          text: data.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    });
  };

  return (
    <PasswordLoginCard
      title="Owner Representative Login"
      icon="fa-building-user"
      onSubmit={handleSubmit}
      forgotPasswordHref="/forgot-password/hotel-owner"
      otpRequired={Boolean(otpChallenge)}
      maskedEmail={otpChallenge.maskedEmail}
      onCancelOtp={() => setOtpChallenge(false)}
    />
  );
};

export default HotelOwnerLoginCard;
